<template>
  <generic-list :model="model" :model-headers="modelHeaders"></generic-list>
</template>

<script>
import model from "./model"

export default {
  name: "List",
  data() {
    return {
      model,
      modelHeaders: [{ text: "Nome", value: "name" }],
    }
  },
}
</script>
